import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Pagination from '../pagination';
import { CustomerAction } from '../../store/actions';

class List extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    customers: PropTypes.object,
    getCustomers: PropTypes.func,
    location: PropTypes.object,
  };

  componentDidMount() {
    this.props.getCustomers(
      Object.fromEntries(new URLSearchParams(this.props.location.search)),
    );
  }

  onSearch(event) {
    const {
      target: { value },
    } = event;
    this.props.getCustomers({ query: value });
  }

  render() {
    const {
      authHasOffice = false,
      customers: { data: customers = [], links = [] } = {},
      getCustomers = () => {},
      location = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Customer</h3>
              <div className="card-tools d-print-none">
                <Pagination
                  getList={getCustomers}
                  links={links}
                  location={location}
                />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div
                  className="input-group input-group-sm"
                  style={{ width: '150px' }}
                >
                  <input
                    className="form-control"
                    onChange={this.onSearch.bind(this)}
                    placeholder="Search"
                    type="text"
                  />
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {customers?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {customers?.length > 0 && (
                <table className="table table-striped text-nowrap">
                  <thead>
                    <tr>
                      {!authHasOffice && <th>Office</th>}
                      <th>ID</th>
                      <th>Name</th>
                      <th>Gender</th>
                      <th>Father Name</th>
                      <th>Address</th>
                      <th>Mobile Number</th>
                      <th>National ID</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customers?.map?.(row => (
                      <tr key={row.id}>
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.id}</td>
                        <td>{row.name}</td>
                        <td>{row.gender}</td>
                        <td>{row.father_name}</td>
                        <td>{row.address}</td>
                        <td>{row.mobile_number}</td>
                        <td>{row.national_id}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  customers: state?.customer?.list,
});

const mapDispatchToProps = dispatch => ({
  getCustomers: params => dispatch(CustomerAction.getCustomers(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
